<div class="list-group-item action" *hideKey="'Seo-Dashboard-RequiredAction-ImplementOnsiteBlog'">
  <div class="d-flex flex-wrap mb-2">
    <div class="mb-1 text-danger custom-required-actions-item-title" style="min-width: 100%">
      <i class="fa fa-exclamation-circle fa-2x text-danger float-start pe-2"></i>{{ 'ra_implement_onsite_blog' | translate }}
    </div>
    <div class="text-muted ms-4 mb-2" style='min-width: 100%'>
      <small>
        <span class="customer-required-actions-text font-italic">
          {{'ra_implement_onsite_blog_desc' | translate: {date: requiredAction.date | date:'shortDate'} }}
        </span>
      </small>
    </div>
    <div class="text-muted ms-4 mb-2" style='min-width: 100%'>
      <small>
        <span class="customer-required-actions-text font-italic">
          {{ 'URL' | translate }}: {{ requiredAction.displayUrl }}
        </span>
      </small>
    </div>
    <div class="ms-auto" style="min-width: 38%" *hideKey="'Seo-Dashboard-RequiredAction-ImplementOnsiteBlog-Button'">
      <button *ngIf="requiredAction.hyperlink" (click)='downloadAndClose()' target="_blank" class="btn btn-primary btn-sm align-self-start w-100" [disabled]="isCsr">
        {{ 'download_and_close' | translate }}
      </button>
    </div>
  </div>
</div>
